export { applyAutoSelectVariants } from './applyAutoSelectVariants'
